angular
	.module 'App.Module.ResetPassword', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'request_reset_password',
				url: '/request_reset_password?is_master_user'
				views:
					main:
						controller: 'RequestResetPasswordController'
						controllerAs: 'vm'
						templateUrl: '@app/reset-password/reset-password.request-reset-password.view.html'
				data:
					require_login: false
					hideMenu: true
					hideSubMenu: true
					showFooter: false
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					logout: (AuthenticationService) ->
						AuthenticationService.logout(false) if AuthenticationService.isLoggedIn()
			.state 'reset_password',
				url: '/reset_password/:identifier?token'
				params:
					identifier:
						value: null
						squash: true
				views:
					main:
						controller: 'ResetPasswordController'
						controllerAs: 'vm'
						templateUrl: '@app/reset-password/reset-password.new-password.view.html'
				data:
					require_login: false
					hideMenu: true
					hideSubMenu: true
					showFooter: false
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					logout: (AuthenticationService) ->
						AuthenticationService.logout(false) if AuthenticationService.isLoggedIn()
